export const USERS_TABLE_COLUMNS = [
  { name: 'userName', title: 'User Name', getCellValue: (row) => row.userName },
  { name: 'impersonate', title: 'Impersonate' },
];
export const USERS_COLUMN_EXTENSIONS = [
  { columnName: 'userName', width: '50%' },
  { columnName: 'impersonate', width: 'auto', align: 'right' },
];
